import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { APP_VERSION } from '../../constants';
import FeedbackLink, { isFeedbackEnabled } from '../../components/FeedbackLink';

const buildDate = __BUILD_DATE__;
const buildDateLocal = new Date(buildDate).toLocaleString();


const PageFooter = () => {
    return (
        <div className="hk-footer">
            <Container as="footer" className="footer">
                <Row>
                    <Col xl={8}>
                        <p className="footer-text">
                            <span className="copy-text">Telescope © {new Date().getFullYear()} BioMADE - All rights reserved.</span> <Link to="#">Privacy Policy</Link><span className="footer-link-sep">|</span><Link to="#">T&amp;C</Link><span className="footer-link-sep">|</span><Link to="/health">System Status</Link>{isFeedbackEnabled() && (<><span className="footer-link-sep">|</span><FeedbackLink /></>)}</p>
                    </Col>
                    <Col xl={4}>
                        <small>version: <strong>{APP_VERSION}</strong> &nbsp;--&nbsp;built: <strong>{buildDateLocal}</strong> </small>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default PageFooter
